import _ from "lodash"
import { useContext } from "react"
import { Route, Routes, Navigate, useLocation } from "react-router-dom"

// Comps
import AuditRoute from "./components/AuditRoute"
import Layout from "../../layout"
import { routesDef, gpraRoutesDef } from "./routesDef"
import { UserContext } from "../../context/userContext"

function RequireAdmin(props) {
  const userCtx = useContext(UserContext)
  const location = useLocation()

  const { children } = props

  const leastPrivilege = Number(props.leastPrivilege)
  const userGroupType = Number(props.userGroupType)

  const allAccessRoleList = [0, 1] // 0: Sys Admin, 1: App Manager

  if (
    userGroupType === -1 ||
    allAccessRoleList.includes(userCtx.session.user.staff_role)
  ) {
    return children
  }

  let isAllow =
    userCtx.session.user.staff_role <= leastPrivilege &&
    userCtx.session.user.staff_group_type === userGroupType

  if (!isAllow) {
    const state = {
      staff_id: userCtx.session.user.staff_id,
      path: location.pathname,
    }
    return <Navigate to="/denied" state={state} replace />
  }
  return children
}

export default function RoutesBuilder() {
  const getRouteElements = (routesDef) => {
    return _.map(routesDef, (route, i) => {
      const { requireAdmin, leastPrivilege, userGroupType, audit, auditType } =
        route
      const element = requireAdmin ? (
        <RequireAdmin
          leastPrivilege={leastPrivilege}
          key={route.path}
          userGroupType={userGroupType}
        >
          <AuditRoute
            key={route.path}
            path={route.path}
            audit={audit}
            auditType={auditType}
            auditTemplateList={route.auditTemplateList || []}
          >
            {route.element}
          </AuditRoute>
        </RequireAdmin>
      ) : (
        <AuditRoute
          key={route.path}
          path={route.path}
          audit={audit}
          auditType={auditType}
          auditTemplateList={route.auditTemplateList || []}
        >
          {route.element}
        </AuditRoute>
      )
      return <Route key={i} path={route.path} element={element} />
    })
  }

  function handleRoutes() {
    const routeList = getRouteElements(routesDef)

    const gpraRoutesDefFiltered = gpraRoutesDef.filter(
      (route) => !route.landing
    )

    const gpraSubRouteList = getRouteElements(gpraRoutesDefFiltered)
    const gpraLandingRoute = gpraRoutesDef.filter((route) => route.landing)[0]

    // This implementation is unclear, particularly regarding the reasoning behind filtering the GPRA routes.
    // By doing so, it bypasses the authorization checks for the GPRA routes and audit processes.
    // To enforce auditing on GPRA routes, a new 'gpraLandingRouteElement' is being created...

    const gpraLandingRouteElement = (
      <AuditRoute
        key={gpraLandingRoute.path}
        path={gpraLandingRoute.path}
        audit={gpraLandingRoute.audit}
      >
        {gpraLandingRoute.element}
      </AuditRoute>
    )

    const gpraRouteList = [
      <Route
        key={gpraLandingRoute.path}
        path={gpraLandingRoute.path}
        element={gpraLandingRouteElement}
      >
        {gpraSubRouteList}
      </Route>,
    ]

    return <Routes>{[...routeList, ...gpraRouteList]}</Routes>
  }

  return <Layout>{handleRoutes()}</Layout>
}
